import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IAppState {
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public robotName = ''
  public talkId = ''
  public userId = ''
  public spinning = false
  public tip = '转人工中...'
  public url: null|string = null

  @Mutation
  private SET_ROBOT_NAME (name: string) {
    this.robotName = name
  }

  @Mutation
  private SET_TALK_ID (talkId: string) {
    this.talkId = talkId
  }

  @Mutation
  private SET_USER_ID (userId: string) {
    this.userId = userId
  }

  @Mutation
  private SET_SPINNING (spinning: boolean) {
    this.spinning = spinning
  }

  @Mutation
  private SET_TIP (tip: string) {
    this.tip = tip
  }

  @Mutation
  private SET_URL (url: null|string) {
    this.url = url
  }

  @Action
  public setRobotName (name: string) {
    this.SET_ROBOT_NAME(name)
  }

  @Action
  public setTalkId (talkId: string) {
    this.SET_TALK_ID(talkId)
  }

  @Action
  public setUserId (userId: string) {
    this.SET_USER_ID(userId)
  }

  @Action
  public setSpinning (spinning: boolean) {
    this.SET_SPINNING(spinning)
  }

  @Action
  public setTip (tip: string) {
    this.SET_TIP(tip)
  }

  @Action
  public playVideo (url: string) {
    this.SET_URL(url)
  }

  @Action
  public closeVideo () {
    this.SET_URL(null)
  }
}

export const AppModule = getModule(App)